export enum DocumentTypeEnum {
	DriverMainPage = 'driver_main_page',
	DriverBackPage = 'driver_back_page',
	PassportMainPage = 'passport_main_page',
	PassportRegPage = 'passport_reg_page',
	StsMainPage = 'sts_main_page',
	StsOwnerPage = 'sts_owner_page',
	Invalid = 'invalid',
}

type Confidence = number | null;

export type RecognizeFieldString = null | {
	value: string | null;
	confidence: Confidence;
};

export type RecognizeFieldNumber = null | {
	value: number | null;
	confidence: Confidence;
};

export type RecognizeFieldCategory = null | {
	value: any;
	confidence: Confidence;
};

export type RecognizeFieldTransportModel = null | {
	value: string | null;
	brand: null | {
		id: string;
		name: string;
	};
	confidence: Confidence;
};

export type RecognizeFieldTransportKind = null | {
	value: string | null;
	kind: null | {
		id: string;
		name: string;
		type: string;
	};
	confidence: Confidence;
};

export interface DriverMainPageRecognizeFields {
	number: RecognizeFieldString;
	issuedAt: RecognizeFieldString;
	expiredAt: RecognizeFieldString;
	categories: RecognizeFieldString;
	name: RecognizeFieldString;
	birthDate: RecognizeFieldString;
	birthPlace: RecognizeFieldString;
	residence: RecognizeFieldString;
}

export interface DriverBackPageRecognizeFields {
	number: RecognizeFieldString;
	issuedAt: RecognizeFieldCategory;
	expiredAt: RecognizeFieldCategory;
}

export interface PassportMainPageRecognizeFields {
	name: RecognizeFieldString;
	firstname: RecognizeFieldString;
	surname: RecognizeFieldString;
	patronymic: RecognizeFieldString;
	gender: RecognizeFieldString;
	number: RecognizeFieldString;
	issuedAt: RecognizeFieldString;
	issuedIn: RecognizeFieldString;
	issuer: RecognizeFieldString;
	issuerCode: RecognizeFieldString;
	birthday: RecognizeFieldString;
	birthplace: RecognizeFieldString;
}

export interface PassportRegPageRecognizeFields {
	registrationAddress: RecognizeFieldString;
	registrationDate: RecognizeFieldString;
}

export interface StsMainPageRecognizeFields {
	number: RecognizeFieldString;
	vin: RecognizeFieldString;
	ident: RecognizeFieldString;
	issuedIn: RecognizeFieldString;
	manufactureYear: RecognizeFieldNumber;
	color: RecognizeFieldString;
	model: RecognizeFieldTransportModel;
	vehicleType: RecognizeFieldTransportKind;
}

export interface StsOwnerPageRecognizeFields {
	number: RecognizeFieldString;
	owner: RecognizeFieldString;
	address: RecognizeFieldString;
	issuedAt: RecognizeFieldString;
}

export interface InvalidRecognizeFields {}

export interface DocumentAttributesMap {
	[DocumentTypeEnum.PassportMainPage]: PassportMainPageRecognizeFields;
	[DocumentTypeEnum.PassportRegPage]: PassportRegPageRecognizeFields;
	[DocumentTypeEnum.DriverMainPage]: DriverMainPageRecognizeFields;
	[DocumentTypeEnum.DriverBackPage]: DriverBackPageRecognizeFields;
	[DocumentTypeEnum.StsMainPage]: StsMainPageRecognizeFields;
	[DocumentTypeEnum.StsOwnerPage]: StsOwnerPageRecognizeFields;
	[DocumentTypeEnum.Invalid]: InvalidRecognizeFields;
}

export type ProcessResponseAttributes =
	| DriverMainPageRecognizeFields
	| DriverBackPageRecognizeFields
	| PassportMainPageRecognizeFields
	| PassportRegPageRecognizeFields
	| StsMainPageRecognizeFields
	| StsOwnerPageRecognizeFields
	| InvalidRecognizeFields;

//----------------------------------------------------------
// user-defined type guards
//----------------------------------------------------------
export function isPassportMainPage(
	documentType: DocumentTypeEnum,
	attributes: ProcessResponseAttributes,
): attributes is PassportMainPageRecognizeFields {
	return documentType === DocumentTypeEnum.PassportMainPage;
}

export function isPassportRegPage(
	documentType: DocumentTypeEnum,
	attributes: ProcessResponseAttributes,
): attributes is PassportRegPageRecognizeFields {
	return documentType === DocumentTypeEnum.PassportRegPage;
}

export function isDriverMainPage(
	documentType: DocumentTypeEnum,
	attributes: ProcessResponseAttributes,
): attributes is DriverMainPageRecognizeFields {
	return documentType === DocumentTypeEnum.DriverMainPage;
}

export function isDriverBackPage(
	documentType: DocumentTypeEnum,
	attributes: ProcessResponseAttributes,
): attributes is DriverBackPageRecognizeFields {
	return documentType === DocumentTypeEnum.DriverMainPage;
}

export function isStsOwnerPage(
	documentType: DocumentTypeEnum,
	attributes: ProcessResponseAttributes,
): attributes is StsOwnerPageRecognizeFields {
	return documentType === DocumentTypeEnum.StsOwnerPage;
}

export function isStsMainPage(
	documentType: DocumentTypeEnum,
	attributes: ProcessResponseAttributes,
): attributes is StsMainPageRecognizeFields {
	return documentType === DocumentTypeEnum.StsMainPage;
}
